import { render, staticRenderFns } from "./AdminClientTable.vue?vue&type=template&id=35ec1450&scoped=true"
import script from "./AdminClientTable.vue?vue&type=script&lang=js"
export * from "./AdminClientTable.vue?vue&type=script&lang=js"
import style0 from "./AdminClientTable.vue?vue&type=style&index=0&id=35ec1450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ec1450",
  null
  
)

export default component.exports